import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';

Vue.use(VueApexCharts);

// eslint-disable-next-line vue/component-definition-name-casing
Vue.component('apexchart', VueApexCharts);
